import { useHttp } from '@/api'
import { httpApi } from '@/api/api'

/**
 * 新規注文情報
 */
export function AddSupInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.AddSupMstInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 編集注文情報
 */
export function ChangeSupInfo(data, callBackFn) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.ChangeSupMstInfo, data)
      .then(res => {
        resolve(res)
        callBackFn()
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検索注文情報
 */
export function GetSupMstInfoByCode(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetSupMstInfoByCode, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検索注文情報
 */
export function GetSelectList() {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetSelectList)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 削除注文情報
 */
export function DeleteSupMstInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.DeleteSupMstInfo, data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}

/**
 * 検索仕入先マスタ情報
 */
export function SearchSupplierInfo(data) {
  return new Promise((resolve, reject) => {
    useHttp()
      .request(httpApi.GetSupInfo,data)
      .then(res => {
        resolve(res)
      })
      .catch(err => {
        reject(err)
      })
  })
}


